module.exports = __webpack_public_path__ + "img/featured-cnbc.fb5e9e7a.svg";